export interface SoundConfigMap {
    [name: string]: string;
}
